import { useMutation } from '@apollo/client';
import { Switch, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { UPDATE_RETURN_ORDER_DETAILS } from './graphql/Mutations';

export const SKIP_CHECKLIST_ALLOWED_STATUSES = [
  'RETURN_REQUESTED',
  'READY_TO_PICKUP',
  'ARRIVED',
];

export const getSkipChecklistValue = (returnOrder) =>
  Boolean(returnOrder?.metadata?.skipPickupInspection);

const SkipChecklistAction = ({ returnOrderId, status, value, disabled }) => {
  const [isSkipped, setIsSkipped] = useState(Boolean(value));
  const [error, setError] = useState('');

  const isAllowedStatus = SKIP_CHECKLIST_ALLOWED_STATUSES?.includes(status);
  const isDisabled = disabled || !returnOrderId || !isAllowedStatus;

  useEffect(() => {
    setIsSkipped(Boolean(value));
  }, [value]);

  const [updateReturnOrderDetails, { loading }] = useMutation(
    UPDATE_RETURN_ORDER_DETAILS,
    { errorPolicy: 'all', onError() {} },
  );

  const handleChange = async (checked) => {
    setError('');
    setIsSkipped(checked);
    const response = await updateReturnOrderDetails({
      variables: {
        where: { id: returnOrderId },
        data: { skipPickupInspection: checked },
      },
    });
    if (response?.data?.updateReturnOrderDetails) return;
    setIsSkipped(!checked);
    setError(
      response?.errors?.[0]?.message || 'Could not update. Please try again.',
    );
  };

  const getTooltipTitle = () => {
    if (error) return error;
    if (!isAllowedStatus) {
      return 'The checklist can only be skipped before the return is picked up.';
    }
    return isSkipped
      ? 'Checklist is skipped for this return'
      : 'Skip the checklist for this return';
  };

  return (
    <Tooltip title={getTooltipTitle()} placement="top" zIndex={4}>
      <span className="d-flex align-center">
        <Switch
          size="small"
          checked={isSkipped}
          loading={loading}
          disabled={isDisabled}
          onChange={handleChange}
        />
      </span>
    </Tooltip>
  );
};

export default SkipChecklistAction;
